<form
  *ngIf="form"
  [formGroup]="form"
  [ngClass]="{ 'linear-cascading-drop-downs': linear }">
  <ng-container *ngFor="let field of configs; let index = index">
    <div
      *ngIf="!field.parent || form.controls[field.parent]?.value"
      class="row mb-3">
      <div class="col">
        <label [for]="field.key" class="form-label tt_norms400"
          >{{ field.label }}
          <span *ngIf="evaluateExpression(field, 'required', field.required)"
            >*</span
          >
        </label>
        <irembogov-tooltip-field-wrapper
          [tooltip]="field.tooltip"
          [tooltipPlacementInput]="field.tooltipPlacement">
        </irembogov-tooltip-field-wrapper>
        <div *ngIf="field.hint && field.hintPosition === 'TOP'">
          <irembogov-hint-field-wrapper
            [hint]="field.hint"
            [childHintPosition]="field.hintPosition">
          </irembogov-hint-field-wrapper>
        </div>
        <irembogov-select
          [loading]="loading[field.key]"
          [formControlName]="field.key"
          [items]="items && items[field.key] ? items[field.key] : null"
          [bindLabel]="field.bindlabel"
          ngDefaultControl
          [bindValue]="field.bindvalue"
          [placeholder]="field.placeholder"
          [labelForId]="field.key"
          [multiple]="field.multiple === true"
          [virtualScroll]="true"
          [required]="field.required"
          (itemSelected)="onSelectChange($event, field.key, index)"
          [max]="field.max"
          [min]="field.min"></irembogov-select>

        <div
          class="invalid-feedback"
          style="display: block"
          *ngIf="
            form.controls[field.key]?.invalid &&
            (form.controls[field.key]?.dirty ||
              form.controls[field.key]?.touched)
          ">
          <ng-container *ngIf="form.controls[field.key]?.errors">
            {{ field.label }}&nbsp;{{ 'is required' | translate }}
          </ng-container>
        </div>
      </div>
      <div *ngIf="field.hint && field.hintPosition !== 'TOP'">
        <irembogov-hint-field-wrapper
          [hint]="field.hint"
          [childHintPosition]="field.hintPosition">
        </irembogov-hint-field-wrapper>
      </div>
    </div>
  </ng-container>
</form>
